import { cn, HStack } from '@zealot/ui';
import { Check, X } from 'lucide-react';

export type OtpStepIconName = 'success' | 'error';

const STEP_ICONS = {
  success: { Icon: Check, className: 'bg-success-muted text-success' },
  error: { Icon: X, className: 'bg-destructive-muted text-destructive' },
};

export const OtpStepIcon = ({ icon }: { icon: OtpStepIconName }) => {
  const { Icon, className } = STEP_ICONS[icon];

  return (
    <HStack justify="center" className={cn('size-16 rounded-full', className)}>
      <Icon className="size-8" />
    </HStack>
  );
};
